import _orderBy from 'lodash/orderBy';

import { BudgetHistory } from 'models/BudgetHistory';

import format from 'utils/format';

import { Label, Percents, Value, Wrapper } from './ExpensesWidgetContent.style';
import ExpensesWidgetChart from './ExpensesWidgetChart';

type ExpensesWidgetContentProps = {
  budgetHistory: BudgetHistory;
};

const ExpensesWidgetContent = ({
  budgetHistory,
}: ExpensesWidgetContentProps) => {
  const sortedExpenses = _orderBy(
    budgetHistory.Expenses,
    (expense) => expense.FiscalYear,
    'asc'
  );

  return (
    <>
      <Wrapper
        spacing={2}
        justifyContent="space-between"
        direction="row"
        sx={{ color: '#224060' }}
      >
        <Label>Suunnitelma {budgetHistory.FiscalYear}</Label>
        <Value>{format.currency(budgetHistory.Budget)}</Value>
      </Wrapper>
      <Wrapper
        spacing={2}
        justifyContent="space-between"
        direction="row"
        sx={{ color: '#218D7A' }}
      >
        <Label>Toteuma {budgetHistory.FiscalYear}</Label>
        <Value>{format.currency(budgetHistory.Actual)}</Value>
      </Wrapper>
      <Wrapper direction="row" justifyContent="flex-end">
        <Percents
          sx={{
            color: budgetHistory.Percentage > 100 ? '#A51010' : '#218D7A',
          }}
        >
          {format.percent(budgetHistory.Percentage)}
        </Percents>
      </Wrapper>
      <ExpensesWidgetChart fiscalYearsBudgets={sortedExpenses} />
    </>
  );
};

export default ExpensesWidgetContent;
